__turbopack_context__.v({
  "blocksBackgroundColor": "CleverTable-module-scss-module__NQSl-G__blocksBackgroundColor",
  "blocksFontColor": "CleverTable-module-scss-module__NQSl-G__blocksFontColor",
  "columnDividerContainer": "CleverTable-module-scss-module__NQSl-G__columnDividerContainer",
  "secondaryNavBackgroundColor": "CleverTable-module-scss-module__NQSl-G__secondaryNavBackgroundColor",
  "table": "CleverTable-module-scss-module__NQSl-G__table",
  "tableCell": "CleverTable-module-scss-module__NQSl-G__tableCell",
  "tableRow": "CleverTable-module-scss-module__NQSl-G__tableRow",
  "themeBackgroundColor": "CleverTable-module-scss-module__NQSl-G__themeBackgroundColor",
  "themeFontColor": "CleverTable-module-scss-module__NQSl-G__themeFontColor",
  "themeFontFamily": "CleverTable-module-scss-module__NQSl-G__themeFontFamily",
  "transitionEnter": "CleverTable-module-scss-module__NQSl-G__transitionEnter",
  "transitionEnterActive": "CleverTable-module-scss-module__NQSl-G__transitionEnterActive",
  "transitionEnterDone": "CleverTable-module-scss-module__NQSl-G__transitionEnterDone",
  "transitionExit": "CleverTable-module-scss-module__NQSl-G__transitionExit",
  "transitionExitActive": "CleverTable-module-scss-module__NQSl-G__transitionExitActive",
  "transitionExitDone": "CleverTable-module-scss-module__NQSl-G__transitionExitDone",
});
